export default __webpack_public_path__ + "static/media/AO.c9b18793.svg";